<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelTitle$ | async"
                   [tooltip]="panelTitle$ | async"
                   icon="tools_terrain"></tm-menubar-button>
